import { GatheringSortMode } from "../types";

const SortModeQueryParamLookup: Record<GatheringSortMode, string> = {
	CaptureTime: "capture",
	// Not actually set. `UploadedTime` is the empty/default sort mode.
	UploadedTime: "upload",
};
export const ReverseSortModeQueryParamLookup: Record<string, GatheringSortMode> = {
	capture: "CaptureTime",
	upload: "UploadedTime",
};
export default SortModeQueryParamLookup;
